import { type FlexibleDataItem } from "../types";

type MediaType = "pdf" | "video" | "image";

/**
 * Gets the media type of a flexible data item
 * The media type is determine by URL or file type or 'remote_details' or 'media_type' itself
 * @param {FlexibleDataItem} item FlexibleDataItem
 * @returns {string} media_type
 * @returns {string} image | video | pdf
 * @returns {string} unknown
 */
export default function getMediaType(item: FlexibleDataItem): MediaType | "unknown" | (string & {}) {
  // Check for media_type property
  if ("media_type" in item && item.media_type) {
    const type = item.media_type.toLowerCase();
    if (type.includes("pdf")) return "pdf";
    if (type.startsWith("image/")) return "image";
    if (type.startsWith("video/")) return "video";
    if (type.includes("document") || type.includes("msword") || type.includes("officedocument")) return "document";
    return type;
  }

  // Check for URL or original_file to determine type
  if ("url" in item && item.url) {
    const url = item.url.toLowerCase();
    if (url.endsWith(".pdf")) return "pdf";
    if (url.endsWith(".mp4") || url.endsWith(".mov") || url.endsWith(".avi")) return "video";
    if (url.endsWith(".jpg") || url.endsWith(".jpeg") || url.endsWith(".png") || url.endsWith(".gif")) return "image";
    if (url.endsWith(".doc") || url.endsWith(".docx")) return "document";
  }

  // Check original file info if available
  if ("original_file" in item && item.original_file?.type) {
    const fileType = item.original_file.type.toLowerCase();
    if (fileType.includes("pdf")) return "pdf";
    if (fileType.includes("video") || fileType.includes("mp4") || fileType.includes("mov")) return "video";
    if (fileType.includes("image")) return "image";
    if (fileType.includes("document") || fileType.includes("msword") || fileType.includes("officedocument")) return "document";
  }

  // Check remote details if available
  if ("remote_details" in item && item.remote_details?.mime) {
    const mimeType = item.remote_details.mime.toLowerCase();
    if (mimeType.includes("pdf")) return "pdf";
    if (mimeType.includes("video")) return "video";
    if (mimeType.includes("image")) return "image";
    if (mimeType.includes("document") || mimeType.includes("msword") || mimeType.includes("officedocument")) return "document";
  }

  return "unknown";
}
